module.exports = __webpack_public_path__ + "img/site_type_img_01.0c29b32a.png";